export default class TextContents {
    constructor() {
        this._ = [];
        this.length = [];
    } 
    getData() {
        return this._.map(it => it.getData());
    }
    setData(d) {
        this._ = d?.map(it => new TextContent(...it)) || [];
        this.length = this._.length;
    }
    add(d) {
        const text = new TextContent(d);
        this._.push(text);
        return text;
    } 
}

class TextContent {
    constructor(text = '', left, top, ...style) {
        this.text = text;
        this.top = top;
        this.left = left; 
;

    }
    getData() {
        const { text, left, top } = this; 
        return { text, left, top };
    }
    update(annot) {
        const { text, left, top } = annot;
        this.text = text;
        this.left = left;
        this.top = top;
    }
}